import React from 'react';

const labels = {
  pending: 'Pending invitation processing',
  invited: 'Invited',
  already_invited: 'Already invited',
  already_on_roster: 'Already on roster',
  dob_required: 'Date of birth required',
  age_ineligible: 'Does not meet this session’s age requirements',
  self: 'Cannot invite yourself',
  unavailable: 'Not available to invite',
  creation_failed: 'Invitation could not be created',
};
const count = (value) => Number.isInteger(value) && value >= 0 ? value : 0;

export function bulkInvitationSummary(data = {}) {
  const invited = count(data.invited_count);
  const skipped = count(data.skipped_count);
  const errors = Array.isArray(data.errors) ? data.errors : [];
  const failed = count(data.result_summary?.failed_count ?? errors.filter(e => e.stage === 'insert').length);
  const warnings = count(data.result_summary?.notification_warning_count ?? errors.filter(e => e.stage === 'notify').length);
  return { text: `${invited} invited · ${skipped} skipped · ${failed} could not be created`, warnings, failed };
}

export default function BulkInvitationResults({ data, clubName }) {
  if (!data) return null;
  const { text, warnings } = bulkInvitationSummary(data);
  const rows = Array.isArray(data.results) ? data.results : null;
  return (
    <section className="mt-3 rounded-lg border border-orange-200 bg-orange-50 p-3" aria-label="Club invitation results" data-testid="bulk-invitation-results">
      <h3 className="font-semibold">Club invitation results{clubName ? ` — ${clubName}` : ''}</h3>
      <p role="status" className="text-sm mt-1">{text}</p>
      {warnings > 0 && <p className="text-sm text-amber-900 mt-2">{warnings} invited; notification processing failed. These invitations remain created.</p>}
      <p className="text-xs text-gray-600 mt-2">Results for this attempt only. Invitation creation does not confirm notification delivery or reserve a spot.</p>
      {rows ? (
        <details className="mt-3" open>
          <summary className="cursor-pointer font-medium">Player results ({rows.length})</summary>
          <ul className="mt-2 max-h-64 overflow-y-auto divide-y divide-orange-200">
            {rows.map((row, index) => (
              <li key={row.user_id || index} className="py-2 text-sm">
                <span className="font-medium">{row.display_name || `Club member ${index + 1}`}</span>
                <span className="block">{labels[row.outcome] || 'Result unavailable'}{row.outcome === 'invited' && row.notification_status === 'processing_failed' ? '; notification processing failed' : ''}</span>
              </li>
            ))}
          </ul>
        </details>
      ) : <p className="text-sm mt-3">Per-player details are unavailable for this response.</p>}
    </section>
  );
}
